import React from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

const FolderOption = props => {
  const {
    folder,
    onSelectFolder,
    className,
    setActiveFolderId,
    activeFolderId,
    setChecked,
  } = props;

  const clickHandler = folder => {
    onSelectFolder(folder);
    setActiveFolderId(folder.id);
    setChecked(true);
  };
  return (
    <div
      role="button"
      tabIndex="0"
      className={`${className} folder-modal-option`}
      onClick={() => clickHandler(folder)}
    >
      <span className="folder-modal-option-title">{folder.title}</span>
      <FontAwesome
        className={`folder-check ${activeFolderId === folder.id ? 'complete' : 'incomplete'}`}
        name="check-circle"
      />
    </div>
  );
};

FolderOption.propTypes = {
  folder: propTypes.object,
  activeFolderId: propTypes.string,
  onSelectFolder: propTypes.func,
  setActiveFolderId: propTypes.func,
  setChecked: propTypes.func,
  className: propTypes.string,
};

export default FolderOption;
